import React, {Component} from 'react';
import {Button, Card, Divider, Empty, Form, List, Tooltip} from "antd/lib/index";
import {connect} from "react-redux";

import {addToMergeList, mergeSpares} from "../../appRedux/actions/SparePart";

class SpaceMergeForm extends Component {
  state = {
    origin: null,
    spares: []
  };

  componentDidMount() {
    this.setState({
      spares: (this.props.mergeData || []).map(spare => {
        const {unit, sparePart, sparePartId} = spare;
        return {unit, sparePart, sparePartId}
      })
    })

    // const spares = (sdata || []).map(spare => {
    //   const {unit, sparePart, sparePartId} = spare;
    //   return {unit, sparePart, sparePartId}
    // });
    // this.setState({spares});
  }

  setOriginSpare = (id) => {
    const origin = this.state.origin;
    const spares = this.state.spares;
    if(origin === null) {
      this.setState({spares: spares.filter(sp => sp.sparePartId.toString() !== id.toString())});
    } else {
      let sps = spares.filter(sp => sp.sparePartId.toString() !== id.toString());
      sps.push(origin);
      console.log(sps, origin);
      this.setState({spares: sps});
    }
    this.setState({origin: spares.filter(sp => sp.sparePartId.toString() === id.toString())[0] || null});
  };

  removeSpare = (id) => {
    const spares = this.state.spares;
    console.log(spares);
    spares.splice(spares.findIndex(a => a.sparePartId === id), 1);
  };

  handleSubmit = () => {
    this.props.mergeSpares(this.state.origin, this.state.spares);
  };

  handleCancel = () => {
    // console.log(`Cancelled!`);
    this.props.addToMergeList([]);
    const history = this.props.history;
    history.goBack();
  };

  handleBack = () => {
    // console.log(`Back!`);
    // this.props.addToMergeList([]);
    const history = this.props.history;
    history.goBack();
  };

  render() {
    return (
      <div>
        <div>
          <h2>Original Spare</h2>
          {this.state.origin ? (
            <Card style={{width: '15vw'}} title={`Unit : ${this.state.origin.unit || ''}`}>
              <div>
                {this.state.origin.sparePart || ''}
              </div>
            </Card>
          ) : <Empty/>
          }
          <Divider/>
          <br/>
          <h2>Spares to merge with original</h2>
          <List
            grid={{
              gutter: 16,
              xs: 1,
              sm: 2,
              md: 4,
              lg: 4,
              xl: 6,
              xxl: 3,
            }}
            dataSource={this.state.spares || []}
            renderItem={item => (
              <List.Item>
                <Card title={`Unit : ${item.unit || ''}`}
                      extra={(<a href='#' onClick={() => this.removeSpare(item.sparePartId)}><Tooltip
                        title="remove from this list">
                        <span style={{color: 'red'}}>X</span>
                      </Tooltip></a>)}>
                  <div>
                    {item.sparePart || ''}
                  </div>
                  <Divider/>
                  <Button size={'small'} type='primary' onClick={() => this.setOriginSpare(item.sparePartId)}>Make this
                    as
                    Original</Button>
                </Card>
              </List.Item>
            )}
          />
        </div>
        <Divider/>
        <div>
          <Button type={'primary'} onClick={this.handleBack}>Back</Button>
          <Button onClick={this.handleCancel}>Cancel</Button>
          <Button disabled={(!this.state.origin || !this.state.spares.length)} size='large'
                  type='primary' onClick={this.handleSubmit}>Merge</Button>
        </div>
      </div>);
  }
}

const mapStateToProps = ({auth, sparePart, commonData}) => {
  return {
    authUser: auth.authUser,

    // resource: spareReport.resource,
    loading: commonData.loading,
    // pageNo: spareReport.pageNo,
    mergeData: sparePart.mergeableSpares,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    mergeSpares,
    addToMergeList
  };
}

const SpaceMerge = Form.create({name: 'spare-merge'})(SpaceMergeForm);
export default connect(mapStateToProps, mapDispatchToProps())(SpaceMerge);
